export default theme => ({
  root: {
    padding: '0 4px',
    borderRadius: 4,
    backgroundColor: theme.colors.actionMajor[500],
    display: 'flex',
    alignItems: 'center'
  }
});